import { useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { useHistory } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { deleteSeniorHomeRequest, getSeniorHomesRequest } from "../redux/actions";
import { AppState } from "../redux/types";
import { localePath } from "../i18n/config";

const SeniorHomesList = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state: AppState) => state.user);
    useEffect(() => {
        if (user && (user.isAdmin || user.role === "it_support" || user.role === "head_nurse")) {
            dispatch(getSeniorHomesRequest());
        } else {
            history.push(localePath("kirjaudu"));
        }
        return () => {};
    }, [dispatch, history, user]);

    const resources = useSelector((state: AppState) => state.seniorHomes);
    const { list, loading, deleted_at, error } = resources;

    const deleteHandler = (id: any) => {
        if (window.confirm("Haluatko varmasti poistaa hälytyksen?")) {
            dispatch(deleteSeniorHomeRequest(id));
        }
    };

    const addNewService = () => {
        history.push("/admin/senior_home/new");
    };

    useEffect(() => {
        dispatch(getSeniorHomesRequest());
    }, [dispatch, deleted_at]);

    return (
        <>
            <div className="global-row-container">
                <h1 className="my-3 ml-3" style={{ color: "#4e5180", fontFamily: "Poppins, sanf-serif" }}>
                    Senior homes
                </h1>
                {(user.isAdmin || user.role === "head_nurse") && (
                    <Button onClick={addNewService} className="add-button">
                        Add a new senior home
                    </Button>
                )}
            </div>
            {loading ? (
                <Loader />
            ) : error ? (
                <Message variant="danger">{error}</Message>
            ) : (
                <Table striped bordered hover responsive className="users-table">
                    <thead className="user-title">
                        <tr className="user">
                            <th className="text-center">{user.readOnly || !user.isAdmin ? "Muokkaa/Poista" : "Päivitä /Poista"}</th>
                            <th className="text-center">ID</th>
                            <th className="text-center">NAME</th>
                            <th className="text-center">REFERENCE</th>
                            <th className="text-center">SHOW</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list &&
                            list.map((senior_home: any) => (
                                <tr key={senior_home.id}>
                                    <td>
                                        <LinkContainer to={`/admin/senior_home/${senior_home.id}`}>
                                            <Button className="btn-sm">
                                                <i className={user.readOnly || !user.isAdmin || !(user.role === "head_nurse") ? "fas fa-eye" : "fas fa-edit"} style={{ color: "#fff" }} />
                                            </Button>
                                        </LinkContainer>
                                        {!user.readOnly && (user.isAdmin || user.role === "head_nurse") && (
                                            <Button variant="danger" className="btn-sm" onClick={() => deleteHandler(senior_home.id)}>
                                                <i className="fas fa-trash" />
                                            </Button>
                                        )}
                                    </td>
                                    <td>{senior_home.id}</td>
                                    <td>{senior_home.name}</td>
                                    <td>{senior_home.reference}</td>
                                    <td>{senior_home.show ? <i className="fas fa-check" style={{ color: "#4e5180" }} /> : <i className="fas fa-times" style={{ color: "red" }} />}</td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
            )}
        </>
    );
};

export default SeniorHomesList;
